
/**
 * 신고 사유
 */
export type ReportRoadmapBodyReason = typeof ReportRoadmapBodyReason[keyof typeof ReportRoadmapBodyReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportRoadmapBodyReason = {
  SPAM: 'SPAM',
  INAPPROPRIATE_CONTENT: 'INAPPROPRIATE_CONTENT',
  COPYRIGHT_VIOLATION: 'COPYRIGHT_VIOLATION',
  MISLEADING_INFO: 'MISLEADING_INFO',
  HARASSMENT: 'HARASSMENT',
  OTHER: 'OTHER',
} as const;
